export const ApiMeta = (json: IApiMeta): IApiMetaModel => {
	const fromJSON = () => {
		const { current_page, last_page, per_page, ...rest } = json
		return {
			currentPage: current_page,
			lastPage: last_page,
			perPage: per_page,
			...rest,
		}
	}
	return { ...fromJSON() }
}

export const ApiResponse = (json: IApiCommon<any>): IApiCommonModel<any> => {
	const fromJSON = () => {
		const { meta, ...rest } = json
		return {
			meta: meta ? ApiMeta(meta) : meta,
			...rest,
		}
	}
	return { ...fromJSON() }
}
